import { useRef } from 'react';

// Component
import GotoPage from "views/components/GotoPage";

// Style & CSS
import "assets/css/Navbar.css";

export default function NavbarPromotion() {
    const pageRef = useRef();
    const gotoPage = () => {
        pageRef.current.gotoPage("/deposit", "notCheckLogin");
    };

    return (
        <>
            <GotoPage ref={pageRef}></GotoPage>

            <div className="navbarPromotion center cursorPointer" onClick={gotoPage}>
                ติดสถานะรับโปรโมชั่น (คลิ๊กดูรายละเอียด)
            </div>
        </>
    );
}